import { SelectableTable } from '@openx/components-table/SelectableTable/SelectableTable';
import { Table, TableName } from '@openx/components-table/Table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDealsProposedSensitiveCategoriesColumns } from '../constants';
import type { DealAdCategoryProposal } from '../model';
import type { ShareDealsSensitiveCategoriesListProps } from '../types';

const DealsSensitiveCategoriesSelectableTable = <T extends Partial<DealAdCategoryProposal>>() =>
  SelectableTable<T>(Table);

export function DealProposedSensitiveCategoriesList({
  items,
  criteria,
  selectedItems,
  rowActions,
  onCriteriaChange,
  onSelectChange,
}: ShareDealsSensitiveCategoriesListProps) {
  const Table = DealsSensitiveCategoriesSelectableTable<DealAdCategoryProposal>();
  const { t } = useTranslation();
  const [primaryAction, dangerAction] = rowActions;
  const columns = useMemo(() => getDealsProposedSensitiveCategoriesColumns(t), [t]);

  return (
    <Table
      loading={false}
      name={TableName.DEALS_SENSITIVE_CATEGORIES_PROPOSED}
      data={items}
      columns={columns}
      selectedItems={selectedItems}
      toggleSelect={onSelectChange}
      criteria={criteria}
      onCriteriaChange={onCriteriaChange}
      primaryRowAction={primaryAction}
      dangerRowAction={dangerAction}
    />
  );
}
